var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-xs": "" } },
    [
      _c(
        "v-card",
        {},
        [
          _c(
            "v-card-title",
            { staticClass: "primary" },
            [
              _c(
                "v-icon",
                { staticClass: "icon-space white--text", attrs: { left: "" } },
                [_vm._v("assignment")]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "ml-4 headline white--text" }, [
                _vm._v("PROJECT MANAGEMENT OVERVIEW")
              ]),
              _c("span", { staticClass: "beta-text ml-3" }, [_vm._v("beta")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  dark: "",
                  "append-icon": "search",
                  label: "Search",
                  "single-line": "",
                  "hide-details": ""
                },
                model: {
                  value: _vm.search,
                  callback: function($$v) {
                    _vm.search = $$v
                  },
                  expression: "search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headersProjects,
              items: _vm.projectsManagementOverview,
              search: _vm.search,
              "rows-per-page-items": [8, 15, 25, { text: "All", value: -1 }],
              light: ""
            },
            scopedSlots: _vm._u([
              {
                key: "items",
                fn: function(props) {
                  return [
                    _c(
                      "tr",
                      {
                        on: {
                          click: function($event) {
                            _vm.setSelectedProject(props.item.id)
                            props.expanded = !props.expanded
                          }
                        }
                      },
                      [
                        _c(
                          "td",
                          [
                            props.item.updateStatus == "3 - green"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "light-green darken-2"
                                    }
                                  },
                                  [_vm._v("star\n            ")]
                                )
                              : props.item.updateStatus == "2 - yellow"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "amber darken-1"
                                    }
                                  },
                                  [_vm._v("info\n            ")]
                                )
                              : props.item.updateStatus == "1 - red"
                              ? _c(
                                  "v-icon",
                                  {
                                    attrs: { large: "", color: "red darken-2" }
                                  },
                                  [_vm._v("warning\n            ")]
                                )
                              : _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      large: "",
                                      color: "secondary darken-3"
                                    }
                                  },
                                  [_vm._v("help\n            ")]
                                )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.cName))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.name))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(props.item.leadName))])
                      ]
                    )
                  ]
                }
              },
              {
                key: "expand",
                fn: function(props) {
                  return [
                    _c("v-card", { attrs: { flat: "" } }, [_c("project")], 1)
                  ]
                }
              },
              {
                key: "pageText",
                fn: function(ref) {
                  var pageStart = ref.pageStart
                  var pageStop = ref.pageStop
                  return [
                    _vm._v(
                      "\n          From " +
                        _vm._s(pageStart) +
                        " to " +
                        _vm._s(pageStop) +
                        "\n      "
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0cce41e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cce41e2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Projects.vue
// module id = Fxs+
// module chunks = 1